import PropTypes from "prop-types";
import React from "react";
import StereotypeProxy from "data/util/StereotypeProxy";
import TreeItemStore from "data/TreeItemStore";
import MergeBodyLayout from "../../mergebodylayout/MergeBodyLayout";
import { FluxMergeRecordSourceTreeGridLayout } from "../../mergebodylayout/FluxMergeRecordSourceTreeGridLayout";

function RecordLabel({record}) {
    return <strong>
        {record.getLabel()}
    </strong>;
}

RecordLabel.propTypes = {
    record: PropTypes.instanceOf(StereotypeProxy).isRequired,
};

class GlobalMergeBody extends React.Component {
    render() {
        const {fluxContext, isMagicRoot, source, target, onCancel, onMerge, sourceChildren} = this.props;
        const typeLabelTitle = target.stereoInfo.name;
        const typeLabel = typeLabelTitle.toLowerCase();
        if(!source) {
            return null;
        }

        const ctx = fluxContext;
        const body = {
            ...this.props,
            // for TreeStore
            ctx: ctx + ":global-merge",
            isKeyExpanded: TreeItemStore.getExpandedTest(ctx),
        };

        return (
            <MergeBodyLayout
                isMagicRoot={isMagicRoot}
                fluxContext={fluxContext}
                sourceLabel={<RecordLabel record={source} />}
                targetLabel={<RecordLabel record={target} />}
                typeLabel={typeLabel}
                sourceChildren={sourceChildren}
                onMerge={onMerge}
                onCancel={onCancel}
            >
                <FluxMergeRecordSourceTreeGridLayout {...body} />
            </MergeBodyLayout>
        );
    }
}

GlobalMergeBody.propTypes = {
    fluxContext: PropTypes.string.isRequired,
    mergePlugin: PropTypes.string.isRequired,
    isMagicRoot: PropTypes.bool,
    target: PropTypes.instanceOf(StereotypeProxy).isRequired,
    source: PropTypes.instanceOf(StereotypeProxy),
    onCancel: PropTypes.func.isRequired,
    onMerge: PropTypes.func.isRequired,
    sourceChildren: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.string.isRequired,
        items: PropTypes.arrayOf(PropTypes.string).isRequired,
    })),
};

export default GlobalMergeBody;



// WEBPACK FOOTER //
// ./app/lib/merge/views/global-merge/GlobalMergeBody.js